import React, { useState } from 'react';
import NewsPart1 from '../components/news/newsPart1';
import NewsDetails from '../components/news/newsdetail';
import Bottom from '../components/bottom'
import { NewsCustomDataProvider } from './context/newsCustomDataProvider';
import "../assets/css/news.css"

const News: React.FC = () => {
    const [currentView, setCurrentView] = useState('mainLogin');
    const [viewData, setViewData] = useState(null);

    const renderView = () => {
        switch (currentView) {
            case 'news':
                return <NewsPart1 handleViewChange={handleViewChange} data={viewData} />;
            case 'newsdetails':
                return <NewsDetails handleViewChange={handleViewChange} data={viewData} />;
            default:
                return <NewsPart1 handleViewChange={handleViewChange} data={viewData} />;
        }
    };

    const handleViewChange = (newView: string, data?: any) => {
        setCurrentView(newView);
        setViewData(data);
    };

    return (
        <NewsCustomDataProvider>
            <div className='page-container'>

                <div className='page-content'>

                <div className='News'>
                {renderView()}
                </div>
                </div>
                <Bottom />
            </div>
        </NewsCustomDataProvider>
    )

};

export default News;
